import { api } from './api'

export interface PendingShipper {
  shipper_id: string
  name: string
  trading_name: string | null
  document: string | null
  email: string | null
  phone: string | null
  created_at: string
}

export async function getPendingShippers(): Promise<PendingShipper[]> {
  const res = await api.get('/master/shippers/pending')
  return res.data.shippers || []
}

export async function setShipperApproval(shipperId: string, approved: boolean): Promise<void> {
  await api.patch(`/master/shippers/${shipperId}/approval`, { approved })
}
